module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_2_2_1-d25b7b3956063a2388742da2284d6aca.webp";